<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">Maps</h1>
<p class="map-para"><a href="#/012_Chapter01#img35">The World of the Bible</a></p>
<p class="map-para"><span href="#/015a_Chapter04#img155" title="Link target outside of Sample">Roman Empire 117 CE</span></p>
<p class="map-para"><span href="#/017_Chapter06#img224" title="Link target outside of Sample">Border Regions of the Roman and Persian Empires</span></p>
<p class="map-para"><span href="#/018_Chapter07#img266" title="Link target outside of Sample">Early Medieval Europe</span></p>
<p class="map-para"><span href="#/019_Chapter08#img330" title="Link target outside of Sample">Persian Eastern Provinces</span></p>
<p class="map-para"><span href="#/019_Chapter08#img334" title="Link target outside of Sample">The Silk Road and Connected Trading Routes</span></p>
<p class="map-para"><span href="#/020_Chapter09#img366" title="Link target outside of Sample">Abbasid Empire</span></p>
<p class="map-para"><span href="#/020_Chapter09#img380" title="Link target outside of Sample">Mongol Empire</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Maps.vue?778e16bd